export default __webpack_public_path__ + "static/media/icon-js.88573fb7.svg";